// File: src/pages/TabCloseAccount.js

import React from 'react';

function CloseAccountTab() {
    return (
        <>
            <div className="card">
                {/* Card header START */}
                <div className="card-header border-0 pb-0">
                    <h5 className="card-title">Delete account</h5>
                    <p className="mb-0">
                        He moonlights difficult engrossed it, sportsmen. Interested
                        has all Devonshire difficulty gay assistance joy.
                        Unaffected at ye of compliment alteration to.
                    </p>
                </div>
                {/* Card header START */}
                {/* Card body START */}
                <div className="card-body">
                    {/* Delete START */}
                    <h6>Before you go...</h6>
                    <ul>
                        <li>
                            Take a backup of your data <a href="/">Here</a>
                        </li>
                        <li>
                            If you delete your account, you will lose your all data.
                        </li>
                    </ul>
                    <div className="form-check form-check-md my-4">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id="deleteaccountCheck"
                        />
                        <label
                            className="form-check-label"
                            htmlFor="deleteaccountCheck"
                        >
                            Yes, I'd like to delete my account
                        </label>
                    </div>
                    <a
                        href="/"
                        className="btn btn-success-soft btn-sm mb-2 mb-sm-0"
                    >
                        Keep my account
                    </a>
                    <a href="/" className="btn btn-danger btn-sm mb-0">
                        Delete my account
                    </a>
                    {/* Delete END */}
                </div>
                {/* Card body END */}
            </div>
        </>
    );
}

export default CloseAccountTab;